const getByteToGigabyte = (bytes: number) => bytes / 1024 ** 3;

export default getByteToGigabyte;
